import { Component, Inject, OnInit } from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-embed-dialog',
  templateUrl: './embed-dialog.component.html',
  styleUrls: ['./embed-dialog.component.scss']
})
export class EmbedDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit(): void {
    
  }

}
